// extracted by mini-css-extract-plugin
export default {"dotsAnimation":"ConnectionAnimatedDots_dotsAnimation__VjrZq","dot":"ConnectionAnimatedDots_dot__boVmo","loading":"ConnectionAnimatedDots_loading__nAiku"};